import React from 'react';
import { IconProps } from './model/IconInterface';

const UndoPersonIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="10" cy="5" r="3" /><path d="M4 21v-1a6 6 0 0 1 9-5.2" /><polyline points="17 12 14 15 17 18" /><line x1="14" y1="15" x2="21" y2="15" />
    </svg>
  );
};

export default UndoPersonIcon;
